import { render, staticRenderFns } from "./MapPointSetter.vue?vue&type=template&id=d52cf7bc&scoped=true&"
import script from "./MapPointSetter.vue?vue&type=script&lang=js&"
export * from "./MapPointSetter.vue?vue&type=script&lang=js&"
import style0 from "./MapPointSetter.vue?vue&type=style&index=0&id=d52cf7bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52cf7bc",
  null
  
)

component.options.__file = "MapPointSetter.vue"
export default component.exports